import { defaultLocale } from '@/lib/i18n/dictionaries';
import { metadata, noFollowExclusions, siteConfig } from '@/lib/i18n/en';
import {
  metadataCN,
  noFollowExclusionsCN,
  siteConfigCN,
} from '@/lib/i18n/zh-cn';

import { getLocaleCache } from './i18n.server';

import IconLogo from '~/svg/IconLogo.svg';
import IconLogoCN from '~/svg/IconLogoCN.svg';

// next-sitemap.config.js - has conditional logic for domain
// next.config.js - has conditional logic for locale

export function currentLocaleConfig() {
  return {
    es: {
      title: siteConfig.title,
      url: siteConfig.url,
      footerAllRightsReserved: (
        <span>deocod.com, Todos los derechos reservados</span>
      ),
      logo: IconLogo,
      noFollowExclusions: noFollowExclusions,
      metadata: metadata,
      metadataOpengraphLocale: 'es',
      dateFormatLocale: 'es',
      site24x7: 'fdd80e82e18f7018a405c106bd50a6f6',
      gtmId: 'GTM-W55WPZS',
    },
    en: {
      title: siteConfig.title,
      url: siteConfig.url,
      footerAllRightsReserved: <span>decodo.com. All Rights Reserved</span>,
      logo: IconLogo,
      noFollowExclusions: noFollowExclusions,
      metadata: metadata,
      metadataOpengraphLocale: 'en_US',
      dateFormatLocale: 'en-US',
      site24x7: 'fdd80e82e18f7018a405c106bd50a6f6',
      gtmId: 'GTM-W55WPZS',
    },
    'zh-cn': {
      title: siteConfigCN.title,
      url: siteConfigCN.url,
      footerAllRightsReserved: (
        <span>
          Decodo 版权所有{' '}
          <a
            href='https://beian.miit.gov.cn/#/Integrated/index'
            target='_blank'
          >
            津ICP备2022004334号-2
          </a>
        </span>
      ),
      logo: IconLogoCN,
      noFollowExclusions: noFollowExclusionsCN,
      metadata: metadataCN,
      metadataOpengraphLocale: 'zh_CN',
      dateFormatLocale: 'zh-CN',
      site24x7: 'a0caf947e447280f0dd3c6066645b8c6',
      gtmId: 'GTM-KWRKZBD',
    },
  }[getLocaleCache() || defaultLocale];
}
